"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".deal-history[_ngcontent-%COMP%]   .mapping-details-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:40px}.deal-history[_ngcontent-%COMP%]   icon[_ngcontent-%COMP%]{margin-top:4px;margin-left:4px}"];
exports.styles = styles;
